import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

const d = (iso) => (iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(2, 4)}` : "");

export const classChangeText = (today, ls) => {
  const last = ls?.class_score?.score;
  if (!ls) return "No official last start: class change 0";
  const where = [ls.venue, d(ls.date)].filter(Boolean).join(" ");
  if (today == null || last == null) return `Last start ${where}: no class score, class change 0`;
  const diff = Math.round((last - today) * 10) / 10;
  return `Last ${last} (${where}) − today ${today} = ${diff > 0 ? "+" : ""}${diff}${diff > 0 ? " dropping in class" : diff < 0 ? " rising in class" : ""}`;
};

const kg = (v) => `${Number(v)}kg`;

export const weightChangeText = (today, ls) => {
  if (!ls) return "No official last start: weight change 0";
  const letter = ls.letter || (/^class [a-e]$/i.test(ls.race_class || "") ? ls.race_class.slice(-1).toUpperCase() : null);
  if (ls.picnic || letter) return `Last start was ${ls.picnic ? "a picnic" : `a Class ${letter}`} race: weight change ignored (0)`;
  const hw = ls.highweight ?? /high\s*-?\s*weight|\bhwt\b/i.test(`${ls.race_name || ""} ${ls.race_class || ""}`);
  const lw = hw ? 60 : ls.weight;
  if (today == null || lw == null) return "Weight missing: weight change 0";
  const diff = Math.round((today - lw) * 10) / 10;
  if (!diff) return `${kg(today)} today, ${kg(lw)} last start${hw ? " (highweight, set at 60kg)" : ""}: same weight = 0`;
  return `${kg(today)} today, ${kg(lw)} last start${hw ? " (highweight, set at 60kg)" : ""}: ${Math.abs(diff)}kg ${diff > 0 ? "more" : "less"} = ${diff > 0 ? "−" : "+"}${Math.abs(diff)}`;
};

export const marginText = (ls, s) => {
  if (!ls) return "No official last start = 0";
  if (ls.finish === 1) return "Won last start = 0";
  if (ls.margin == null) return "Margin missing = 0";
  const w = s?.weight ?? 0.75;
  const raw = Math.round(ls.margin * w * 100) / 100;
  const capped = s && s.weighted > -raw;
  return `Beaten ${ls.margin}L × ${w} = −${raw}${capped ? `, capped at ${String(s.weighted).replace("-", "−")}` : ""}`;
};

export const HoverTip = ({ text, children, testId }) => (
  <TooltipProvider delayDuration={100}>
    <Tooltip>
      <TooltipTrigger asChild><span className="cursor-help underline decoration-dotted decoration-slate-500 underline-offset-2" data-testid={testId}>{children}</span></TooltipTrigger>
      <TooltipContent className="text-xs" data-testid={testId && `${testId}-tip`}>{text}</TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

export const ClassChangeTip = ({ today, ls, children, testId }) => <HoverTip text={classChangeText(today, ls)} testId={testId}>{children}</HoverTip>;
